import React from 'react';

export interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  src?: string | null;
  initials?: string;
  size?: 'sm' | 'md' | 'lg';
  alt?: string;
}

export function Avatar({
  src,
  initials,
  size = 'md',
  alt = 'Avatar',
  className = '',
  ...props
}: AvatarProps) {
  const sizes = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
  };

  return (
    <div
      className={`${sizes[size]} rounded-full bg-primary-container overflow-hidden ring-2 ring-primary-container flex items-center justify-center ${className}`}
      {...props}
    >
      {src ? (
        <img alt={alt} className="w-full h-full object-cover" src={src} />
      ) : (
        <span className="text-primary font-black uppercase">{initials || '?'}</span>
      )}
    </div>
  );
}
